import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import Home from './Main/Home'

function Routers() {
    return (
        <Router browserHistory>
            <Switch>
                <Route exact path='/' component={Home}/>
            </Switch>
        </Router>
    )
}

export default Routers;